import { BASE_URL } from '../configs/config';
import Auth from '../libs/auth-wrapper';
import { apiFetch } from '../libs/apiFetch';

export const getUserInfo = async (userId: string) => {
  try {
    const idToken = await Auth.getIdToken();

    const res = await apiFetch(`${BASE_URL}checkRestInfo?user_id=${userId}`, {
      method: 'GET',
      cache: 'no-cache',
      headers: {
        ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {}
};
